/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.skills.SkillActivationSource
*/
export var SkillActivationSource;
(function (SkillActivationSource) {
    SkillActivationSource["FRONTMATTER"] = "FRONTMATTER";
    SkillActivationSource["DERIVED"] = "DERIVED";
    SkillActivationSource["OVERRIDE"] = "OVERRIDE";
})(SkillActivationSource || (SkillActivationSource = {}));
//# sourceMappingURL=SkillActivationSource.js.map